export interface AccountClientClass {
    AccountPartyId: number
    PartyTypeId: number
    AccountId: number
    PartyName: string
    ClientName: string
    ClientCode: string
    PartyNick: string
    EMailAddress: string
    Address1: string
    Address2: string
    CountryId: number
    State: string
    City: string
    ZipCode: string
    Telephone1: string
    Telephone2: string
    Fax: string
    DefaultCurrencyId: number
    DefaultBillingRate: number
    Website: string
    Notes: string
    IsDisabled: boolean
    IsDeleted: boolean
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number
    CustomField1: string
    CustomField2: string
    CustomField3: string
    CustomField4: string
    CustomField5: string
    CustomField6: string
    CustomField7: string
    CustomField8: string
    CustomField9: string
    CustomField10: string
    CustomField11: string
    CustomField12: string
    CustomField13: string
    CustomField14: string
    CustomField15: string
    FixedBidBillingMode: number
    FixedCost: number
    AccountPartyGuidId: string
    ExternalReferenceId: string
    ExternalAppId: string
    isSelected: number
    AccountClientId: number
    AccountInvoiceTemplateId: string
}
const common = {    
    AccountPartyId: '',
    AccountClientId:'',
    PartyTypeId: 0,
    AccountId: 0,
    PartyName: '',
    ClientName: '',
    ClientCode: '',
    EMailAddress: '',
    Address1: '',
    Address2: '',
    CountryId: 0,
    State: '',
    City: '',
    ZipCode: '',
    Telephone1: '',
    Telephone2: '',
    Fax: '',
    DefaultCurrencyId: 0,
    DefaultBillingRate: 0,
    Website: '',
    Notes: '',
    IsDisabled: false,
    IsDeleted: false,
    CreatedOn: '',
    CreatedByEmployeeId: 0,
    ModifiedOn: '',
    ModifiedByEmployeeId: 0,
    CustomField1: '',
    CustomField2: '',
    CustomField3: '',
    CustomField4: '',
    CustomField5: '',
    CustomField6: '',
    CustomField7: '',
    CustomField8: '',
    CustomField9: '',
    CustomField10: '',
    CustomField11: '',
    CustomField12: '',
    CustomField13: '',
    CustomField14: '',
    CustomField15: '',
    FixedBidBillingMode: 0,
    FixedCost: 0,
    AccountPartyGuidId: '',
    ExternalReferenceId: '',
    ExternalAppId: '',
    AccountInvoiceTemplateId: ''
  };

  export const ClientInitialsForAdd = {
     ...common 
    };

 

  export const ClientInitialsForUpdate = {
    ...common,
  };